var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"podcast-list"},[_vm._l((_vm.list),function(item,index){return _c('AudioPlayer',{key:index,attrs:{"item":item}})}),_vm._v(" "),(_vm.next)?_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":_vm.loadMore}},[_vm._v("Load more")]):_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599bd130","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Podcast.vue
// module id = ZoKJ
// module chunks = 0